// src/user/LocalStorageUtil.js

const STORAGE_KEY = 'userSession';

const LocalStorageUtil = {
  saveSession: (sessionData) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(sessionData));
    } catch (error) {
      console.error('Failed to save session data:', error);
    }
  },

  getSession: () => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Failed to parse session data:', error);
      return null;
    }
  },

  clearSession: () => {
    localStorage.removeItem(STORAGE_KEY);
  }
};

export default LocalStorageUtil;